const notFound = {
  error: "Sorry， the page you visited does not exist",
  backHome: "Back to home"
} 
export default notFound